import { useQuery } from '@apollo/client/react';
import { type UnreadNotificationCountQuery, type UnreadNotificationCountQueryVariables } from '../../__generated__/graphql-client-types';
import { UNREAD_NOTIFICATION_COUNT } from '../../queries/notifications/notifications.queries';

export const useUnreadProjectNotificationCount = (projectId: number) => {
	const { data: unreadNotifications, refetch: refetchUnreadCount } = useQuery<
		UnreadNotificationCountQuery,
		UnreadNotificationCountQueryVariables
	>(UNREAD_NOTIFICATION_COUNT, {
		variables: {
			input: {
				projectId
			}
		}
	});

	const unreadProjectNotificationCount = unreadNotifications?.customer?.unreadNotificationCount || 0;

	return { unreadProjectNotificationCount, refetchUnreadCount };
};
